import axios from 'axios'
import { constructAndReturnValidationErrorMessage } from './PreviewUtils'

const APIENDPOINT = process.env.REACT_APP_TRAQR_BACKEND_DOMAIN_NAME

export const getCampaigns = async (bearerToken) => {
  try {
    const response = await axios.get(`https://${APIENDPOINT}/campaigns`, {
      headers: {
        Authorization: bearerToken,
      },
    })
    switch (response.status) {
      case 200:
        {
          const data = await response.data
          return data
        }
      case 400:
        return null

      case 404:
        return null

      case 500:
        return null

      default:
        return null
    }
  } catch {
    return null
  }
}

export const fetchExistingCampaigns = async (bearerToken) => {
  let message
  try {
    const response = await axios.get(`https://${APIENDPOINT}/campaigns`, {
      headers: {
        Authorization: bearerToken,
      },
      validateStatus: (status) => status < 500,
    })
    console.log('response', response)

    switch (response.status) {
      case 200:
        {
          const data = await response.data
          return {
            success: true,

            data: data.records,
          }
        }
      case 404:
        message = 'No campaigns exist for this user currently'

        return {
          success: false,
          error: message,
        }

      default:
        message =
          'Something went wrong while attempting to display data on the screen.'
        return {
          success: false,
          error: message,
        }
    }
  } catch {
    message =
      'Something went wrong while attempting to display data on the screen.'
    return {
      success: false,
      error: message,
    }
  }
}
export const createCampaign = async (payload, bearerToken) => {
  const response = await axios.post(
    `https://${APIENDPOINT}/campaigns`,
    payload,
    {
      headers: {
        Authorization: bearerToken,
        'Content-Type': 'application/json',
      },
      validateStatus: (status) => status <= 500,
    },
  )
  return response
}

export const uploadContactsToAPI = async (csvFile, payload, bearerToken) => {
  const formData = new FormData()
  Object.entries(payload).forEach(([key, value]) => formData.append(key, value))
  formData.append('file', csvFile)

  try {
    const response = await axios.post(`https://${APIENDPOINT}/bulk`, formData, {
      headers: {
        Authorization: bearerToken,
        'Content-Type': 'multipart/form-data',
      },
      validateStatus: (status) => status <= 500,
    })

    if (response.status === 200) {
      return {
        success: true,
        message: 'Contacts uploaded successfully',
        data: response.data,
      }
    }
    return {
      success: false,
      message: response.data?.message || 'Unexpected error occurred',
    }
  } catch (err) {
    console.error(err)
    return {
      success: false,
      message: 'Upload failed. Please contact support.',
    }
  }
}

export const saveCustomizationToDB = async (data, bearerToken) => {
  try {
    const response = await axios.post(
      `https://${APIENDPOINT}/templates`,

      {
        form_data: data,
      },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: bearerToken,
        },
        validateStatus: (status) => status <= 500,
      }
    );
    return response;
  } catch (error) {
    return response;
  }
};


export const viewPreviewPdf = async (formData, BEARER) => {
  try {
    const action = "VIEW";
    const response = await axios.post(
      `https://${APIENDPOINT}/preview`,
      { ...formData, action: action },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: BEARER,
        },
        responseType: "arraybuffer",
        validateStatus: (status) => status >= 200 && status <= 500,
      }
    );
    if (response.status === 200) {
      const data = response.data;

      return {
        success: true,
        data: data,
      };
    } else if (response.status === 400) {
      const decoder = new TextDecoder("utf-8");
      const responseText = decoder.decode(response.data);
      const responseJson = JSON.parse(responseText);
      if (responseJson.errors && responseJson.errors.length > 0) {
        const errorMessage = responseJson.errors[0].qrCodeContent;
        return {
          success: false,
          message: errorMessage,
        };
      }
      return {
        success: false,
        message: responseJson.message || "The request was invalid. Please check your inputs.",
      };
    } else if (response.status === 404) {
      return {
        success: false,
        message: response.data.message || "Template not found.",
      };
    } else if (response.status === 500) {
      return {
        success: false,
        message:
          "The operation you attempted has failed. Please contact support.",
      };
    }
  } catch (error) {
    return {
      success: false,
      message:
        "The operation you attempted has failed. Please contact support.",
    };
  }
};

export const getCustomizedTemplatesCreatedByUser = async (bearerToken) => {
  try {
    const response = await axios.get(`https://${APIENDPOINT}/templates`, {
      headers: {
        Authorization: bearerToken,
      },
      validateStatus: (status) => status < 500,
    });
    switch (response.status) {
      case 200:
        return response.data.records;
      case 404:
        return [];
      default:
        return [];
    }
  } catch (error) {
    let message = 'The operation you attempted has failed.Please contact support.'
    return message
  }
};


export const fetchTemplatesConfig = async (bearerToken) => {
  try {
    const response = await axios.get(`https://${APIENDPOINT}/template-configs`, {
      headers: {
        Authorization: bearerToken,
      },
      validateStatus: (status) => status <= 500,
    });
    return response;
  } catch {
    let message = "The operation you attempted has failed. Please contact support.";
    return message;
  }
};

export const fetchTemplateConfigDetails = async (owner, name, bearerToken) => {
  try {
    const response = await axios.get(`https://${APIENDPOINT}/template-configs`, {
      params: {
        name: name,
        owner: owner,
      },
      headers: {
        Authorization: bearerToken,
      },
      validateStatus: (status) => status <= 500,
    });
    return response;
  } catch (error) {
    return {
      status: 500,
      message: "The operation you attempted has failed. Please contact support.",
    };
  }
};

export const requestForPDFGeneration = async (
  campaign,
  template,
  bearerToken,
) => {
  try {
    const response = await axios.post(
      `https://${APIENDPOINT}/requests`,
      {
        campaign: campaign,
        template: template,
      },

      {
        headers: {
          Authorization: bearerToken,
        },
        timeout: 30000,
        validateStatus: (status) => status < 500,
      },
    )
    switch (response.status) {
      case 201:
        return {
          success: true,
          message: "Your request to 'Generate Print Collaterals' is accepted.\nIt will take some time to process your request.\nYou can refresh the grid to see the status of your request.",
          data: response.data,
        }
      case 409:
        return {
          success: false,
          error:
            'Request with the same values is already created. Please download the file from the grid when it is complete',
        }
    }
  } catch (error) {
    return {
      success: false,
      error: error.message,
    }
  }
}

export const fetchPdfGenerationRequestsForCustomer = async (bearerToken) => {
  try {
    const response = await axios.get(`https://${APIENDPOINT}/requests`, {
      headers: {
        Authorization: bearerToken,
      },
      validateStatus: (status) => status < 500,
    })
    console.log('response of requests', response)
    switch (response.status) {
      case 200:
        {
          const data = await response.data
          return data
        }
      case 404:
        return response.data
    }
  } catch (error) {
    console.log('error', error.message)
    return error.message
  }
}

export const fetchCampaigns = async (BEARER) => {
  return await axios.get(`https://${APIENDPOINT}/campaigns`, {
    headers: {
      Authorization: BEARER,
    },
    validateStatus: (status) => status >= 200 && status < 500,
  })
}

export const fetchRespondedContacts = async (campaignName, BEARER) => {
  return await axios.get(`https://${APIENDPOINT}/records`, {
    headers: {
      Authorization: BEARER,
    },
    params: {
      campaign: campaignName,
    },
    validateStatus: (status) => status >= 200 && status < 500,
  })
}

export const fetchContactVisits = async (trackable, BEARER) => {
  return await axios.get(`https://${APIENDPOINT}/related`, {
    params: {
      path: trackable,
    },
    headers: {
      Authorization: BEARER,
    },
    validateStatus: (status) => status >= 200 && status < 500,
  })
}

export const fetchUsersFromDB = async (BEARER) => {
  return await axios.get(`https://${APIENDPOINT}/users`, {
    headers: {
      Authorization: BEARER,
    },
    validateStatus: (status) => status >= 200 && status < 500,
  })
}

export const createUser = async (name, user_name, email, phone, BEARER, action) => {
  try {
    console.log(`Creating user with name: ${name}, userName: ${user_name}, email: ${email}, phone: ${phone}, action: ${action}`)
    const response = await axios.post(
      `https://${APIENDPOINT}/users`,
      { name, user_name, email, phone, action },
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: BEARER,
        },
        validateStatus: (status) => status >= 200 && status <= 500,
      },
    )

    if (response.status === 201) {
      const data = response.data
      return {
        success: true,
        message: `An account for email ${data.details.email} has been created successfully. Associated customer ID is ${data.details.customer_id}`,
      }
    } else if (response.status === 400) {
      return {
        success: false,
        message: 'Request received with empty values for one or more required parameter.'
      }
    }
    else if (response.status === 409) {
      return {
        success: false,
        message: `User with email ${email} already exists. Please use a different email address.`,
      }
    } else if (response.status === 500) {
      return {
        success: false,
        message: `The operation you attempted has failed. Please contact support.`,
      }
    } else {
      return {
        success: false,
        message: response.data?.message || `Unexpected error occurred (Status: ${response.status}).`,
      }
    }
  } catch {
    return {
      success: false,
      message: `A network request exception occurred`,
    }
  }
}

export const generatePreviewPdf = async (formData, BEARER) => {
  try {
    const action = "PREVIEW";
    const response = await axios.post(
      `https://${APIENDPOINT}/preview`,
      { ...formData, action: action },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: BEARER,
        },
        responseType: "arraybuffer",
        validateStatus: (status) => status >= 200 && status <= 500,
      }
    );
    if (response.status === 200) {
      const data = response.data;

      return {
        success: true,
        data: data,
      };
    } else if (response.status === 400) {
      const decoder = new TextDecoder("utf-8");
      const responseText = decoder.decode(response.data);
      const responseJson = JSON.parse(responseText);
      if (responseJson.errors && responseJson.errors.length > 0) {
        const errorMessage = responseJson.errors[0].qrCodeContent;
        return {
          success: false,
          message: errorMessage,
        };
      }
      return {
        success: false,
        message: responseJson.message || "The request was invalid. Please check your inputs.",
      };

    } else if (response.status === 422) {
      const responseJson = JSON.parse(new TextDecoder().decode(response.data));
      return {
        success: false,
        message: constructAndReturnValidationErrorMessage(responseJson, "Validation Errors:"),
      };
    } else if (response.status === 500) {
      return {
        success: false,
        message:
          "The operation you attempted has failed. Please contact support.",
      };
    }
  } catch (error) {
    return {
      success: false,
      message:
        "The operation you attempted has failed. Please contact support.",
    };
  }
};

export const sendEmail = async (bearerToken, email, sub) => {
  try {
    const action = "RESEND_ONBOARDING_EMAIL";
    const response = await axios.post(`https://${APIENDPOINT}/users`,
      {
        email: email,
        sub: sub,
        action: action
      },
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: bearerToken,
        },
        validateStatus: (status) => status <= 500,
      })
    const data = response.data;
    if (response.status === 200) {
      return {
        success: true,
        message: `${data.message} ${email}`,
      }
    } else if (response.status === 400) {
      return {
        success: false,
        message: data,
      }
    } else if (response.status === 404) {
      return {
        success: false,
        message: `User with email ${email} does not exist.`,
      }
    }
    else if (response.status === 409) {
      return {
        success: false,
        message: data.message,
      }
    }
    else if (response.status === 422) {
      return {
        success: false,
        message: data.message,
      }
    }
    else if (response.status === 500) {
      return {
        success: false,
        message: `The operation you attempted has failed. Please contact support.`,
      }
    }
  } catch (error) {
    return {
      success: false,
      message: `The operation you attempted has failed. Please contact support.`,

    }
  }
}


export const editUserPartners = async (bearerToken, sub, partners) => {
  try {
    const response = await axios.patch(`https://${APIENDPOINT}/users/${sub}`,
      {
        partners: partners,
      },
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: bearerToken,
        },
        validateStatus: (status) => status <= 500,
      })
    const data = response.data;
    if (response.status === 200) {
      return {
        success: true,
        message: data.message || `User updated successfully`,
      }
    }
    else if (response.status === 400) {
      return {
        success: false,
        message: data.message || `Failed to update user`,
      }
    }
    else if (response.status === 404) {
      return {
        success: false,
        message: data.message || `User not found`,
      }
    }
    else if (response.status === 422) {
      return {
        success: false,
        message: data.message || `Invalid inputs`,
      }
    }
    else if (response.status === 500) {
      return {
        success: false,
        message: data.message || `The operation you attempted has failed. Please contact support.`,
      }
    } else {
      return {
        success: false,
        message: data.message || `The operation you attempted has failed. Please contact support.`,
      }
    }
  } catch (error) {
    return {
      success: false,
      message: `The operation you attempted has failed. Please contact support.`,
    }
  }
}

export const fetchAdminActivityLogs = async (bearerToken) => {
  try {
    const response = await axios.get(`https://${APIENDPOINT}/activity-logs`, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: bearerToken,
      },
      validateStatus: (status) => status <= 500,
    });
    return response;
  } catch (error) {
    return {
      success: false,
      message: `The operation you attempted has failed. Please contact support.`,
    }
  }
}

export const updateUserStatus = async (bearerToken, userId, accountStatus, route) => {
  try {
    const response = await axios.patch(`https://${APIENDPOINT}/${route}`,
      {
        sub: userId,
        status: accountStatus
      },
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: bearerToken,
        },
        validateStatus: (status) => status <= 500,
      }
    )
    console.log('response of update user status', response)
    const data = response.data;
    if (response.status === 200) {

      return {
        success: true,
        message: `${data.message}`,
      }
    } else if (response.status === 400) {
      return {
        success: false,
        message: data,
      }
    } else if (response.status === 404) {
      return {
        success: false,
        message: `User with ID ${userId} does not exist.`,
      }
    } else if (response.status === 500) {
      return {
        success: false,
        message: `The operation you attempted has failed. Please contact support.`,
      }
    }

  } catch (error) {
    return {
      success: false,
      message: `The operation you attempted has failed. Please contact support.`
    }
  }
}